import { memo } from 'react'
import { observer } from 'mobx-react'
import { useRootStore } from 'stores/utils/hooks/useRootStore'
import { scrollToElement } from 'utils/pollard/scroll'
import useVoucherAmount from '../../hooks/useVoucherAmount'
import { VOUCHER_ACTIVATION_BANNER_ID } from '../../VoucherBanner.constants'
import { VoucherBannerVariant } from '../../VoucherBanner.types'
import {
  BannerContainer,
  Illustration,
  TextContent,
  Title,
  Subtitle
} from './TopNotActivatedVoucherBanner.styles'
import { VARIANT_COPY } from './TopNotActivatedVoucherBanner.constants'

interface TopNotActivatedVoucherBannerProps {
  variant: VoucherBannerVariant
}

function TopNotActivatedVoucherBannerComponent({
  variant
}: TopNotActivatedVoucherBannerProps) {
  const voucherAmount = useVoucherAmount()
  const { rootStore } = useRootStore()
  const { subtitle, illustration, title } = VARIANT_COPY[variant]

  const handleNavigateToActivationBanner = () => {
    const el = document.getElementById(VOUCHER_ACTIVATION_BANNER_ID)
    if (!el) return
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    if (isSafari) {
      scrollToElement(el, rootStore.isInIframe)
    } else {
      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    }
  }

  return (
    <BannerContainer
      variant={variant}
      clickable
      onClick={handleNavigateToActivationBanner}
    >
      <TextContent>
        <Illustration
          src={illustration(voucherAmount)}
          alt={`Illustration for ${variant} voucher banner`}
          variant={variant}
          aria-hidden="true"
        />
        <Title variant={variant}>{title(voucherAmount)}</Title>
        <Subtitle variant={variant}>{subtitle}</Subtitle>
      </TextContent>
    </BannerContainer>
  )
}

export const TopNotActivatedVoucherBanner = memo(
  observer(TopNotActivatedVoucherBannerComponent)
)
